export default import.meta.ROLLDOWN_FILE_URL_gTjKqIVCw7uI3M8zY2UvBA